// Import components
import { useLocation } from "react-router-dom";
import './Admindashboard.css';
import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { Modal, ModalHeader, Card, CardBody, Row, Col, Input, Alert } from 'reactstrap';
import axios from "axios";

interface Category {
    id: number;
    name: string;
    subcats: { id: number; name: string }[];
}

// interface TableRow {
//     id: number;
//     name: string;
// }

interface TableRow {
    id: number;
    categoryId: number;  // Parent category ID
    categoryName: string;
    subcategoryId: number;
    subcategoryName: string;
}

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const SubCategoryManagement = () => {




    const location = useLocation();
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: 'Messages here.', time: '2500' });

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };

    const [showloader, setshowloader] = useState(true);
    const [selectedSubcategory, setSelectedSubcategory] = useState<{ id: number; name: string } | null>(null);

    const [modal_center, setmodal_center] = useState(false);
    const [delete_modal, setmodal_center_delete] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
    const [categories, setCategories] = useState<Category[]>([]);
    const [tableData, setTableData] = useState<TableRow[]>([]);
    const [modal_standard, setmodal_standard] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [subcategories, setSubcategories] = useState('');
    const [allCategories, setAllCategories] = useState<Category[]>([]);


    function addCategory() {
        setmodal_center(!modal_center);
        removeBodyCss();
        setErrors({ subcategories: '' });
    }


    function deleteCategory() {
        setmodal_center_delete(!modal_center);
        removeBodyCss();

    }


    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }


    const [deleteIdCat, setDeleteIdCat] = useState<number | null>(null);
    const [deleteDialogOpenCat, setDeleteDialogOpenCat] = useState(false);
    const [deleteSubcategoryId, setDeleteSubCatId] = useState(null);
    const selectRef = React.useRef<HTMLSelectElement>(null);



    const handleDeleteClickCat = (id: number) => {
        setDeleteIdCat(id);
        setDeleteDialogOpenCat(true);
    };

    const [errors, setErrors] = useState({ subcategories: '' });

    const SaveSubcategory = async () => {
        // if (!subcategories || subcategories.trim() === '') {
        //     alert('Subcategory field is required!');
        //     return;
        // }

        const newErrors: any = {};

        if (!subcategories || subcategories.trim() === '') { newErrors.subcategories = 'Subcategory is required'; }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const currentCategory = selectRef.current?.value;
        try {
            const response = await axios.post('accounts/handleadmcategory', {
                iscat: false,
                action: "add",
                category: currentCategory,
                subcategory: subcategories
            })
            if (response.status === 'DONE') {
                setmodal_center(false)
                setSubcategories('');
                fetchCategories();
                setAlertMsgg({ ...alertMsgg, open: true, content: "Subcategory created successfully!", type: "success", });
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
            }

        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout" }, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            }
        }

    }

    const [editErrors, setEditErrors] = useState({ subcategory: '' });

    const EditSubcategory = async () => {
        // if (!selectedCategory || !selectedSubcategory || !selectedSubcategory.name.trim()) {
        //     alert("Please make sure both Category and Subcategory are filled!");
        //     return;
        // }
        const newErrors: any = {};

        if (!selectedSubcategory || !selectedSubcategory.name.trim()) {
            newErrors.subcategory = 'Subcategory name is required';
        }

        if (!selectedCategory) {
            newErrors.category = 'Category must be selected';
        }

        if (Object.keys(newErrors).length > 0) {
            setEditErrors(newErrors);
            return;
        }
        try {
            const response = await axios.post('accounts/handleadmcategory', {
                action: "edit",
                iscat: false,
                cid: selectedCategory!.id,
                scid: selectedSubcategory!.id,
                category: selectedCategory!.name,
                subcategory: selectedSubcategory!.name,
            });
            if (response.status === "DONE") {
                setmodal_standard(!modal_standard);

                fetchCategories();
                setAlertMsgg({ ...alertMsgg, open: true, content: "Subcategory updated successfully!", type: "success", });
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);

            }

        } catch (error) {
            console.error("Error saving subcategory changes:", error);
        }
    };


    const handleConfirmDeleteCat = async () => {
        try {
            const response = await axios.post('accounts/handleadmcategory', { iscat: false, scid: deleteSubcategoryId, action: "delete" })
            console.log('check the response -----', response)
            if (response.status === 'DONE') {
                setmodal_center_delete(false)
                fetchCategories()
                setAlertMsgg({ ...alertMsgg, open: true, content: "Subcategory deleted successfully!", type: "success", });
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
            }

        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout" }, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }

    };



    const handleCancelDeleteCat = () => {
        setDeleteDialogOpenCat(true);
        setDeleteIdCat(null);
    };

    async function tog_standard(subcategoryId?: number) {
        if (subcategoryId) {

            const updatedCategory = await fetchCategories(); // 🧠 Wait for updated category

            if (updatedCategory) {
                const subcat = updatedCategory.subcats.find(sc => sc.id === subcategoryId);

                if (subcat) {
                    setSelectedSubcategory(subcat);
                } else {
                    console.warn('Subcat not found for ID:', subcategoryId);
                }
            } else {
                console.warn('No category found');
            }
        }

        setmodal_standard(!modal_standard);
        removeBodyCss();
        setEditErrors({ subcategory: '' });
    }


    const handleSaveSubcategory = () => {
        if (selectedSubcategory && selectedCategory) {
            const updatedSubcats = selectedCategory.subcats.map(sc =>
                sc.id === selectedSubcategory.id ? selectedSubcategory : sc
            );

            setSelectedCategory({
                ...selectedCategory,
                subcats: updatedSubcats
            });

            // Also update in the main table data
            const updatedTableData = tableData.map(row =>
                row.subcategoryId === selectedSubcategory.id
                    ? { ...row, subcategoryName: selectedSubcategory.name }
                    : row
            );
            setTableData(updatedTableData);

            setmodal_standard(false);
        }
    };


    const columns: column[] = useMemo(
        () => [
            {
                header: 'Index',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => row.index + 1,
            },
            // {
            //     header: 'Category',
            //     accessorKey: 'categoryName',
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: ({ row }) => (
            //         <span>{row.original.categoryName === 'hr' ? 'Hr' : row.original.categoryName}</span>
            //     )
            // },
            {
                header: 'Subcategory',
                accessorKey: 'subcategoryName',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => (
                    <span className="text-capitalize">{row.original.subcategoryName}</span>
                )
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-dark btn-sm"
                            type="button"
                            onClick={() => tog_standard(row.original.subcategoryId)}
                        >
                            Edit
                        </button>

                        <button className="btn btn-danger btn-sm"
                            onClick={() => {
                                setDeleteSubCatId(row.original.subcategoryId); // or whatever key holds the ID
                                deleteCategory(); // this opens the modal
                            }}>
                            <i className="bx bxs-trash-alt me-1"></i> Delete
                        </button>
                    </div>
                ),
            }
        ],
        []
    );

    const fetchCategories = async () => {
        try {
            setshowloader(true)
            const response = await axios.get(`/accounts/all_categories`, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 'SENT') {
                setshowloader(false)
                const searchParams = new URLSearchParams(location.search);
                const categoryId = searchParams.get("category_id");
                const categoryIdInt = categoryId ? parseInt(categoryId, 10) : null;

                const fetchedCategories: Category[] = response.CategoriesData || [];
                const currentCategory = fetchedCategories.find(cat => cat.id === categoryIdInt);


                setAllCategories(fetchedCategories);

                if (currentCategory) {
                    setCategories([currentCategory]);
                    setSelectedCategory(currentCategory);
                    const subcatTableData = currentCategory.subcats.map(subcat => ({
                        id: subcat.id,
                        categoryId: currentCategory.id,
                        categoryName: currentCategory.name,
                        subcategoryId: subcat.id,
                        subcategoryName: subcat.name
                    }));
                    setTableData(subcatTableData);
                    return currentCategory;
                }

            }
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout" }, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };
    useEffect(() => {
        fetchCategories();
    }, []);

    document.title = "Sub Categories | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

                <Breadcrumbs title="Sub Categories" breadcrumbItem="Sub Categories" />

                <Row>
                    <Col md={12}>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-primary mb-3" onClick={() => addCategory()}>
                                + Add Subcategory
                            </button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={tableData}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />

                                {/* {selectedCategory && (
                        <div className="mt-4 p-3 border rounded">
                        <h4>Selected Category Details</h4>
                        <div className="mb-3">
                            <h5>Category Name: <span className="text-primary">{selectedCategory.name}</span></h5>
                        </div>
                        
                        <div className="mb-3">
                            <h5>Subcategories:</h5>
                            <ul className="list-group">
                            {selectedCategory.subcats.map((subcat, index) => (
                                <li key={index} className="list-group-item">
                                {subcat.name}
                                </li>
                            ))}
                            </ul>
                        </div>
                        </div>
                    )} */}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Add Modal */}
                <Modal
                    isOpen={modal_center}
                    toggle={() => setmodal_center(false)}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => setmodal_center(false)}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Add SubCategory
                        </div>
                    </ModalHeader>

                    <div className="modal-body p-4">
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Category<span className="text-danger px-1">*</span></label>

                                    {/* <Input
                        type="text"
                        placeholder="Enter category name"
                        onChange={(e) => setCategoryName(e.target.value)}
                        /> */}

                                    <select
                                        className="form-control"
                                        value={selectedCategory?.name || 'Category Not Selected.'}
                                        onChange={(e) => setCategoryName(e.target.value)}
                                        ref={selectRef}
                                        disabled={true}
                                    >
                                        {allCategories.map((cat) => (
                                            <option key={cat.id} value={cat.name}>
                                                {cat.name.charAt(0).toUpperCase() + cat.name.slice(1)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Subcategory Name<span className="text-danger px-1">*</span></label>
                                    <Input
                                        className={`form-control ${errors.subcategories ? 'is-invalid' : ''}`}
                                        type="text"
                                        // onChange={(e) => setSubcategories(e.target.value)}
                                        placeholder="Enter Subcategory Name"
                                        required
                                        onChange={(e) => {
                                            setSubcategories(e.target.value);
                                            setErrors((prev) => ({ ...prev, subcategories: '' })); // clear error
                                        }}
                                    />
                                    {errors.subcategories && <div className="invalid-feedback">{errors.subcategories}</div>}
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn btn-primary"
                            onClick={SaveSubcategory}
                        >
                            Save
                        </button>
                    </div>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal
                    isOpen={delete_modal}
                    toggle={() => setmodal_center_delete(false)}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => setmodal_center_delete(false)}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Delete Category
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this category?</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={() => { setmodal_center_delete(false); }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={handleConfirmDeleteCat}
                        >
                            Delete
                        </button>
                    </div>
                </Modal>

                {/* edit Modal */}
                <Modal
                    isOpen={modal_standard}
                    toggle={() => {
                        tog_standard();
                    }}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader toggle={() => {
                        tog_standard();
                    }}>
                        <div className="modal-title mt-0 h5">
                            Edit Subcategory
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Category<span className="text-danger px-1">*</span></label>
                                    {/* <Input
                                type="text"
                                value={selectedCategory?.name || ''}
                                disabled
                            /> */}

                                    <select
                                        className="form-control"
                                        value={selectedCategory?.name || ''} // 💡 this sets the current selected option
                                        onChange={(e) => {
                                            setCategoryName(e.target.value);
                                            const selected = allCategories.find(cat => cat.name === e.target.value);
                                            if (selected) setSelectedCategory(selected); // 👈 update selectedCategory as well if needed
                                        }}
                                        disabled={true}
                                    >
                                        {allCategories.map((cat) => (
                                            <option key={cat.id} value={cat.name}>
                                                {cat.name.charAt(0).toUpperCase() + cat.name.slice(1)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Subcategory Name<span className="text-danger px-1">*</span> </label>
                                    <Input
                                        type="text"
                                        value={selectedSubcategory?.name || ""}
                                        // onChange={(e) => {
                                        //     if (selectedSubcategory) {
                                        //         setSelectedSubcategory({
                                        //         ...selectedSubcategory,
                                        //         name: e.target.value
                                        //         });
                                        //     }
                                        // }}
                                        onChange={(e) => {
                                            if (selectedSubcategory) {
                                                setSelectedSubcategory({
                                                    ...selectedSubcategory, name: e.target.value
                                                });
                                                setEditErrors((prev) => ({ ...prev, subcategory: '' }));
                                            }
                                        }}
                                        placeholder="Edit subcategory name"
                                        className={`form-control ${editErrors.subcategory ? 'is-invalid' : ''}`}
                                    />
                                    {editErrors.subcategory && <div className="invalid-feedback">{editErrors.subcategory}</div>}
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-primary"
                            onClick={EditSubcategory}
                        >
                            Save Changes
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default SubCategoryManagement;